import Vue from 'vue';
import store from '@/store/store'
import VueSocketIO from 'vue-socket.io';
import io from 'socket.io-client';

// Vue.use(VueSocketIO, SocketInstance)

Vue.use(new VueSocketIO({
  debug: true,
  withCredentials: true,
  connection: io(process.env.VUE_APP_SOCKET_URL),
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))
